import { HomePage } from "@/components/HomePage";
import "./index.css";

export function App() {
  return <HomePage />;
}

export default App;
